module.exports = __webpack_public_path__ + "static/img/雨夹雪.f7bb13c2.svg";